import { setWorkerUrl } from "maplibre-gl";
import workerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";

// Vite emits the ESM worker as a same-origin asset; v6 no longer inlines it.
setWorkerUrl(workerUrl);
